export default "__VITE_ASSET__DQ3T_U3O__"